import React from "react";
import Layout from "../layout/Layout";

const Terminos = () => {
    return (
        <Layout>
            <div class="text-justify p-5 pb-20">
  El Cuerpo de Bomberos del Cantón Manta con la finalidad de proporcionar los
  servicios institucionales de manera digital, incorpora para los ciudadanos, el
  Acuerdo de Responsabilidad y Uso de Medios Electrónicos. Con este antecedente
  el “Ciudadano” ,
  acepta las siguientes condiciones relacionadas con la utilización de la
  “Clave de Usuario” y “Tecnología”, para la solicitud, presentación y consulta
  de trámites, cumplimiento de obligaciones de carácter administrativo,
  financiero, tributario u otros deberes formales, así como para recibir
  notificaciones de actuaciones administrativas de todo tipo, incluyendo la
  citación del auto de pago, en el correo electrónico registrado a través de
  Internet en el portal institucional 
  <a target="_blank" href="https://bomberosmanta.gob.ec">bomberosmanta.gob.ec</a>, 
  y para acceder a otros servicios que el Cuerpo de Bomberos de Manta ponga a
  su disposición por el medio indicado u otros similares. <br /><br />

  El Ciudadano, mediante la aceptación en línea de este acuerdo, manifiesta su
  deseo y conformidad en utilizar los mecanismos virtuales habilitados en
  nuestro sitio web para recibir notificaciones y citaciones de acciones
  administrativas, para lo cual expresa su voluntad de utilizar el medio de
  notificación y citación a través de Internet; en el buzón personal que el
  Cuerpo de Bomberos de Manta pone a su disposición en los portales web
  institucionales  <a target="_blank" href="https://bomberosmanta.gob.ec">bomberosmanta.gob.ec</a>&nbsp;
  y vía correo electrónico registrado en el mismo portal, expresando y otorgando
  su consentimiento para ello. El Ciudadano conoce y acepta expresamente que la
  aceptación en línea de este acuerdo no impide al Cuerpo de Bomberos de Manta
  cuando las circunstancias así lo requieran, en realizar el acto de
  notificación y/o citación por los otros medios establecidos en la Ley.<br /><br />

  La notificación y citación electrónica realizada por medio del portal
  electrónico mencionado en este Acuerdo, implica el acto por el cual el Cuerpo
  de Bomberos de Manta da a conocer al Ciudadano, una actuación administrativa
  contenida en un mensaje de datos. Dicho mensaje de datos se lo entiende como
  toda información creada, generada, procesada, enviada, recibida, comunicada o
  archivada por medios electrónicos, de conformidad con el Artículo 13 de la
  Resolución No. 009-NG-DINARDAP-2021 - Aviso de Protección de Datos Personales.
  Los documentos electrónicos, de conformidad con lo establecido en la Ley de
  Comercio Electrónico, Firmas Electrónicas y Mensajes de Datos, su Reglamento y
  la Ley de Defensa al Consumidor tienen el mismo valor jurídico que los
  documentos escritos, por lo cual el acceso a los mismos será entendido como el
  acceso al documento original.<br /><br />

  El Ciudadano, entiende y acepta expresamente que la notificación y/o citación
  de actuaciones administrativas realizada a través de Internet, se entenderá
  practicada a todos los efectos legales en el momento de su recepción en el
  buzón del contribuyente y correos electrónicos dentro de los portales web
  institucionales
  <a target="_blank" href="https://bomberosmanta.gob.ec"
    >bomberosmanta.gob.ec</a
  >
  del Cuerpo de Bomberos de Manta, verificará por medio de sus herramientas
  informáticas, el día y hora exactos en el que se produjo dicha recepción y
  sentará, por medio del funcionario competente, la constancia de notificación
  y/o citación pertinente, como prueba de haberse realizado conforme lo
  establece el Código Orgánico Administrativo y Código Orgánico Tributario.<br /><br />

  <strong>Responsabilidad del Ciudadano.</strong> <br />
  El Ciudadano, asume la responsabilidad total del uso, tanto de la clave de
  usuario, así como de la veracidad de la información en el cumplimiento de sus
  obligaciones administrativas, tributarias u otros deberes formales, y la
  utilización de los servicios que Cuerpo de Bomberos de Manta ponga a su
  disposición a través de Internet. Conforme a los principios de simplicidad
  administrativa, seguridad en el manejo de la información y neutralidad
  tecnológica, la seguridad de las transacciones realizadas y servicios
  prestados por medio en los portales web institucional del Cuerpo de Bomberos
  de Manta se garantizará mediante la clave de usuario del contribuyente y de su
  uso se derivarán todas las responsabilidades legales del Ciudadano, de
  conformidad con la ley.<br /><br />

  El Ciudadano asume la responsabilidad total del uso de la clave de usuario
  como titular de esta, debiendo cumplir con las obligaciones derivadas de tal
  titularidad. El Cuerpo de Bomberos de Manta, a través de sus portales web
  institucionales
  <a target="_blank" href="https://bomberosmanta.gob.ec">bomberosmanta.gob.ec</a
  >, pone a disposición Ciudadano un sistema de consulta que permita revisar las
  notificaciones y/o citaciones enviadas a través de la Internet. <br /><br />
  El Ciudadano titular de la clave debe acceder al portal web institucional
  <a target="_blank" href="https://bomberosmanta.gob.ec"
    >bomberosmanta.gob.ec</a
  >
  del Cuerpo de Bomberos de Manta, mediante la clave que el portal le asigna al
  momento de aceptar el presente acuerdo, debiendo la misma ser reemplazada
  posteriormente por otra secreta que el Ciudadano defina. La responsabilidad
  derivada de la falta de cuidado, de la indebida reserva, del mal uso o del uso
  por terceros autorizados o no mediante mandato del titular de la clave,
  ocasionándose o no perjuicios, será exclusivamente del Ciudadano titular de
  dicha clave o en su defecto de su respectivo representante legal.<br /><br />
  El Ciudadano se compromete a ingresar periódicamente a los portales web
  institucionales
  <a target="_blank" href="https://bomberosmanta.gob.ec">bomberosmanta.gob.ec</a
  >, así como también recibirá en la dirección de correo registrado en el portal
  web institucional
  <a href="https://bomberosmanta.gob.ec">bomberosmanta.gob.ec</a>, a fin de
  revisar las notificaciones y/o citaciones que por dicho medio le sean
  periódicamente realizadas de parte del Cuerpo de Bomberos de Manta así como
  los certificados, permisos documentos, informes y reportes por estar enviados
  en la fecha en la que fue efectuada la respectiva notificación y/o citación,
  así como también acceder al contenido de las mismas. La omisión en el
  cumplimiento de esta obligación no afectará la validez jurídica de la
  notificación o citación realizada, sin perjuicio de las responsabilidades y
  sanciones a que haya lugar.<br /><br />
  <strong>
    Restricción de responsabilidad del Cuerpo de Bomberos de Manta
  </strong>
  <br />
  El Cuerpo de Bomberos de Manta no será responsable por las pérdidas o daños
  sufridos por el Ciudadano o a causa de terceros y/o debido a fallas
  tecnológicas bajo responsabilidad de este. El Cuerpo de Bomberos de Manta no
  tiene responsabilidad por la exactitud, veracidad, contenido o por cualquier
  error en la información proporcionada por el Ciudadano, sea que se trate de
  errores humanos o tecnológicos. El Ciudadano tiene la obligación de comunicar
  inmediatamente al Cuerpo de Bomberos de Manta cualquier cambio en la dirección
  electrónica y demás datos que señale en el presente acuerdo. <br /><br />
  <strong>Autorización</strong> <br />
  El Ciudadano autoriza libre y voluntariamente que los datos proporcionados en
  el Portal de Servicios Institucionales puedan ser utilizados en procesos
  exclusivos del Cuerpo de Bomberos de Manta. <br /><br />
  <strong>Aceptación</strong> <br />
  El Ciudadano suscribe este acuerdo por su propia iniciativa y se acepta
  voluntariamente a lo aquí estipulado. El Ciudadano acepta la validez de este
  acuerdo, de la clave de usuario que se le proporciona, las notificaciones y
  citaciones electrónicas de actuaciones administrativas que le envíe el Cuerpo
  de Bomberos de Manta, así como de las declaraciones u otra información que
  envíe a la Administración haciendo uso de los sistemas o medios electrónicos
  que el Cuerpo de Bomberos de Manta ponga a su disposición. Cualquier
  información relativa al uso de la Clave de Usuario, así como los reportes de
  envió de citaciones y/o notificaciones electrónicas, el Ciudadano las recibirá
  en la dirección de correo registrado en el portal web institucional
  <a target="_blank" href="https://bomberosmanta.gob.ec"
    >bomberosmanta.gob.ec</a
  >
  <br /><br />
  <strong>Vigencia</strong> <br />
  Este acuerdo de responsabilidad y uso de medios electrónicos tendrá vigencia
  por tiempo indefinido, a menos que el Ciudadano manifieste su voluntad de
  poner fin al mismo, notificándola con por lo menos 30 días de anticipación.
  Sin perjuicio de ello, el Cuerpo de Bomberos de Manta podrá en cualquier
  momento dar por terminado este acuerdo, comunicando del particular al
  Ciudadano con por lo menos 30 días de anticipación. <br /><br />
            </div>
        </Layout>
    );
};

export default Terminos;
